import { NonConformityStatus } from '../interfaces/treatment';

export class MNonConformityStatus{
    public id: number = null;
    public name: string = null;
    public order: number = null;

    constructor(status: NonConformityStatus){
        this.id = status.id;
        this.name = status.nombre;
        this.order = parseFloat(status.orden)
    }
}